
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index_457Aw_45IC_7HztKkcANq9ubmjPHXBwMDD5pKkqCBV5roIMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/index.vue?macro=true";
import { default as index8hzlHEQbjVvNhpI_9jPe7ZigqAPwUd8VJ3jUnqKWTu0Meta } from "/codebuild/output/src3507326296/src/luckywise/pages/set-up/index.vue?macro=true";
import { default as lucky_45number_456BQNieBm2D1YhyRbJFG4wv1sWzVkqlSkgENbA3jtqcMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/set-up/lucky-number.vue?macro=true";
import { default as favorite_45lotteryjBlnDQLuv1cp2_45GyALTtJ84ocMVkMuCKVVkVw9cvd5cMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/set-up/favorite-lottery.vue?macro=true";
import { default as set_45upCQZ2vMovac0wZqmiPU9tVnf_fBuxkrlNBs3Gz5CiENgMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/set-up.vue?macro=true";
import { default as cookies_vvo7nTHvGERVPANBjmCuhhsNThC92y8W907loFPRwgMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/cookies.vue?macro=true";
import { default as indexOhhbvpGE8o_UZZ7i0ZefCUBxiyMthZTRkVpk6nKCQk8Meta } from "/codebuild/output/src3507326296/src/luckywise/pages/results/scan/index.vue?macro=true";
import { default as alertsnHGhQfX0oJ7JibQLzWhFDflz3V_45HU9VNoV9PofOi_yMMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/results/scan/alerts.vue?macro=true";
import { default as _91id_93GlEsopRF0OiuJdMGUE_m0J03prQaTYxeE_45O75fr93TIMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/results/scan/history/[id].vue?macro=true";
import { default as indexFe4EN5WHTfg35h2CgUBOfoI_45Sk3t1p2N5cgH9pd6hfEMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/results/scan/history/index.vue?macro=true";
import { default as historyykY_rqDFM8UduxnKwWmsxvzpSfog8RSpcNJkiT94BVEMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/results/scan/history.vue?macro=true";
import { default as scannere8k5gMfYkQClbIn_454EktSSm9QwYuEGfHcT4XHeIDamEMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/results/scan/scanner.vue?macro=true";
import { default as scan7tNO_old_vnwaHgGUKkX9Ctr77GcEp5Cg1vi0DdcSqAMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/results/scan.vue?macro=true";
import { default as index5M3mRzDehJ6JZ1cWqY0Vx_A9fqa_QtLAIUjZidlP5x0Meta } from "/codebuild/output/src3507326296/src/luckywise/pages/results/index.vue?macro=true";
import { default as historyQKb2gz4kIHjbMIgtsgrZGJzAI9b7E_mkkRPJfoMuv_45IMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/results/history.vue?macro=true";
import { default as analyticsQfkwJJp_45IBbctfkzn_45gipAEGOGn1L233BtKBVuNxNjIMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/results/analytics.vue?macro=true";
import { default as lotteriesycITaDXm7fFzUnnZpD2AzIz_4505TmMe01If9RJ_45meoOcMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/results/lotteries.vue?macro=true";
import { default as resultscO07JQ_Kq9VyATYD2b3N5jyuGFj3OGYDM6unXuk2znIMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/results.vue?macro=true";
import { default as _91token_932aJXYtgzXdHz26x9yfVBYasFHuJgF1oiMffT94yx65AMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/auth/[token].vue?macro=true";
import { default as access_45deniedvstioEaQp1qvNGnP0Qd4UrxscHRXaokd9Q3g1YaVanIMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/access-denied.vue?macro=true";
import { default as privacy_45policyhwxa6o2ppLyxbh_rIhe8pg4VoBLChwA7SbygHGpbVwIMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/privacy-policy.vue?macro=true";
import { default as terms_45of_45servicec7UvTpXF47aJhtjc37j0sct6y0T1MjQDiZ6MCKwwsngMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/terms-of-service.vue?macro=true";
import { default as responsible_45gamingmmDR5yE4uPsQDh8a9_frlN4fSo1dGG1jilb1GK6Z8zAMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/responsible-gaming.vue?macro=true";
import { default as _91token_93iB2LiP9GNm_45WgbGzo9m6RrXjk_45bAiJWxVIbXV5pQq4gMeta } from "/codebuild/output/src3507326296/src/luckywise/pages/activate-account/[token].vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/index.vue")
  },
  {
    name: set_45upCQZ2vMovac0wZqmiPU9tVnf_fBuxkrlNBs3Gz5CiENgMeta?.name,
    path: "/set-up",
    meta: set_45upCQZ2vMovac0wZqmiPU9tVnf_fBuxkrlNBs3Gz5CiENgMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/set-up.vue"),
    children: [
  {
    name: "set-up___en",
    path: "",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/set-up/index.vue")
  },
  {
    name: "set-up-lucky-number___en",
    path: "lucky-number",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/set-up/lucky-number.vue")
  },
  {
    name: "set-up-favorite-lottery___en",
    path: "favorite-lottery",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/set-up/favorite-lottery.vue")
  }
]
  },
  {
    name: set_45upCQZ2vMovac0wZqmiPU9tVnf_fBuxkrlNBs3Gz5CiENgMeta?.name,
    path: "/pt/set-up",
    meta: set_45upCQZ2vMovac0wZqmiPU9tVnf_fBuxkrlNBs3Gz5CiENgMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/set-up.vue"),
    children: [
  {
    name: "set-up___pt",
    path: "",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/set-up/index.vue")
  },
  {
    name: "set-up-lucky-number___pt",
    path: "lucky-number",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/set-up/lucky-number.vue")
  },
  {
    name: "set-up-favorite-lottery___pt",
    path: "favorite-lottery",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/set-up/favorite-lottery.vue")
  }
]
  },
  {
    name: set_45upCQZ2vMovac0wZqmiPU9tVnf_fBuxkrlNBs3Gz5CiENgMeta?.name,
    path: "/fr/set-up",
    meta: set_45upCQZ2vMovac0wZqmiPU9tVnf_fBuxkrlNBs3Gz5CiENgMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/set-up.vue"),
    children: [
  {
    name: "set-up___fr",
    path: "",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/set-up/index.vue")
  },
  {
    name: "set-up-lucky-number___fr",
    path: "lucky-number",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/set-up/lucky-number.vue")
  },
  {
    name: "set-up-favorite-lottery___fr",
    path: "favorite-lottery",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/set-up/favorite-lottery.vue")
  }
]
  },
  {
    name: "cookies___en",
    path: "/cookies",
    meta: cookies_vvo7nTHvGERVPANBjmCuhhsNThC92y8W907loFPRwgMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/cookies.vue")
  },
  {
    name: "cookies___pt",
    path: "/pt/cookies",
    meta: cookies_vvo7nTHvGERVPANBjmCuhhsNThC92y8W907loFPRwgMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/cookies.vue")
  },
  {
    name: "cookies___fr",
    path: "/fr/cookies",
    meta: cookies_vvo7nTHvGERVPANBjmCuhhsNThC92y8W907loFPRwgMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/cookies.vue")
  },
  {
    name: resultscO07JQ_Kq9VyATYD2b3N5jyuGFj3OGYDM6unXuk2znIMeta?.name,
    path: "/results",
    meta: {"middleware":["result"]},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results.vue"),
    children: [
  {
    name: scan7tNO_old_vnwaHgGUKkX9Ctr77GcEp5Cg1vi0DdcSqAMeta?.name,
    path: "scan",
    meta: { ...(scan7tNO_old_vnwaHgGUKkX9Ctr77GcEp5Cg1vi0DdcSqAMeta || {}), ...{"middleware":["scan"]} },
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan.vue"),
    children: [
  {
    name: "results-scan___en",
    path: "",
    meta: indexOhhbvpGE8o_UZZ7i0ZefCUBxiyMthZTRkVpk6nKCQk8Meta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/index.vue")
  },
  {
    name: "results-scan-alerts___en",
    path: "alerts",
    meta: alertsnHGhQfX0oJ7JibQLzWhFDflz3V_45HU9VNoV9PofOi_yMMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/alerts.vue")
  },
  {
    name: historyykY_rqDFM8UduxnKwWmsxvzpSfog8RSpcNJkiT94BVEMeta?.name,
    path: "history",
    meta: historyykY_rqDFM8UduxnKwWmsxvzpSfog8RSpcNJkiT94BVEMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/history.vue"),
    children: [
  {
    name: "results-scan-history-id___en",
    path: ":id()",
    meta: _91id_93GlEsopRF0OiuJdMGUE_m0J03prQaTYxeE_45O75fr93TIMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/history/[id].vue")
  },
  {
    name: "results-scan-history___en",
    path: "",
    meta: indexFe4EN5WHTfg35h2CgUBOfoI_45Sk3t1p2N5cgH9pd6hfEMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/history/index.vue")
  }
]
  },
  {
    name: "results-scan-scanner___en",
    path: "scanner",
    meta: scannere8k5gMfYkQClbIn_454EktSSm9QwYuEGfHcT4XHeIDamEMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/scanner.vue")
  }
]
  },
  {
    name: "results___en",
    path: "",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/index.vue")
  },
  {
    name: "results-history___en",
    path: "history",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/history.vue")
  },
  {
    name: "results-analytics___en",
    path: "analytics",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/analytics.vue")
  },
  {
    name: "results-lotteries___en",
    path: "lotteries",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/lotteries.vue")
  }
]
  },
  {
    name: resultscO07JQ_Kq9VyATYD2b3N5jyuGFj3OGYDM6unXuk2znIMeta?.name,
    path: "/pt/results",
    meta: {"middleware":["result"]},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results.vue"),
    children: [
  {
    name: scan7tNO_old_vnwaHgGUKkX9Ctr77GcEp5Cg1vi0DdcSqAMeta?.name,
    path: "scan",
    meta: { ...(scan7tNO_old_vnwaHgGUKkX9Ctr77GcEp5Cg1vi0DdcSqAMeta || {}), ...{"middleware":["scan"]} },
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan.vue"),
    children: [
  {
    name: "results-scan___pt",
    path: "",
    meta: indexOhhbvpGE8o_UZZ7i0ZefCUBxiyMthZTRkVpk6nKCQk8Meta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/index.vue")
  },
  {
    name: "results-scan-alerts___pt",
    path: "alerts",
    meta: alertsnHGhQfX0oJ7JibQLzWhFDflz3V_45HU9VNoV9PofOi_yMMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/alerts.vue")
  },
  {
    name: historyykY_rqDFM8UduxnKwWmsxvzpSfog8RSpcNJkiT94BVEMeta?.name,
    path: "history",
    meta: historyykY_rqDFM8UduxnKwWmsxvzpSfog8RSpcNJkiT94BVEMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/history.vue"),
    children: [
  {
    name: "results-scan-history-id___pt",
    path: ":id()",
    meta: _91id_93GlEsopRF0OiuJdMGUE_m0J03prQaTYxeE_45O75fr93TIMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/history/[id].vue")
  },
  {
    name: "results-scan-history___pt",
    path: "",
    meta: indexFe4EN5WHTfg35h2CgUBOfoI_45Sk3t1p2N5cgH9pd6hfEMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/history/index.vue")
  }
]
  },
  {
    name: "results-scan-scanner___pt",
    path: "scanner",
    meta: scannere8k5gMfYkQClbIn_454EktSSm9QwYuEGfHcT4XHeIDamEMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/scanner.vue")
  }
]
  },
  {
    name: "results___pt",
    path: "",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/index.vue")
  },
  {
    name: "results-history___pt",
    path: "history",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/history.vue")
  },
  {
    name: "results-analytics___pt",
    path: "analytics",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/analytics.vue")
  },
  {
    name: "results-lotteries___pt",
    path: "lotteries",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/lotteries.vue")
  }
]
  },
  {
    name: resultscO07JQ_Kq9VyATYD2b3N5jyuGFj3OGYDM6unXuk2znIMeta?.name,
    path: "/fr/results",
    meta: {"middleware":["result"]},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results.vue"),
    children: [
  {
    name: scan7tNO_old_vnwaHgGUKkX9Ctr77GcEp5Cg1vi0DdcSqAMeta?.name,
    path: "scan",
    meta: { ...(scan7tNO_old_vnwaHgGUKkX9Ctr77GcEp5Cg1vi0DdcSqAMeta || {}), ...{"middleware":["scan"]} },
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan.vue"),
    children: [
  {
    name: "results-scan___fr",
    path: "",
    meta: indexOhhbvpGE8o_UZZ7i0ZefCUBxiyMthZTRkVpk6nKCQk8Meta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/index.vue")
  },
  {
    name: "results-scan-alerts___fr",
    path: "alerts",
    meta: alertsnHGhQfX0oJ7JibQLzWhFDflz3V_45HU9VNoV9PofOi_yMMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/alerts.vue")
  },
  {
    name: historyykY_rqDFM8UduxnKwWmsxvzpSfog8RSpcNJkiT94BVEMeta?.name,
    path: "history",
    meta: historyykY_rqDFM8UduxnKwWmsxvzpSfog8RSpcNJkiT94BVEMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/history.vue"),
    children: [
  {
    name: "results-scan-history-id___fr",
    path: ":id()",
    meta: _91id_93GlEsopRF0OiuJdMGUE_m0J03prQaTYxeE_45O75fr93TIMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/history/[id].vue")
  },
  {
    name: "results-scan-history___fr",
    path: "",
    meta: indexFe4EN5WHTfg35h2CgUBOfoI_45Sk3t1p2N5cgH9pd6hfEMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/history/index.vue")
  }
]
  },
  {
    name: "results-scan-scanner___fr",
    path: "scanner",
    meta: scannere8k5gMfYkQClbIn_454EktSSm9QwYuEGfHcT4XHeIDamEMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/scan/scanner.vue")
  }
]
  },
  {
    name: "results___fr",
    path: "",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/index.vue")
  },
  {
    name: "results-history___fr",
    path: "history",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/history.vue")
  },
  {
    name: "results-analytics___fr",
    path: "analytics",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/analytics.vue")
  },
  {
    name: "results-lotteries___fr",
    path: "lotteries",
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/results/lotteries.vue")
  }
]
  },
  {
    name: "auth-token___en",
    path: "/auth/:token()",
    meta: _91token_932aJXYtgzXdHz26x9yfVBYasFHuJgF1oiMffT94yx65AMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/auth/[token].vue")
  },
  {
    name: "auth-token___pt",
    path: "/pt/auth/:token()",
    meta: _91token_932aJXYtgzXdHz26x9yfVBYasFHuJgF1oiMffT94yx65AMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/auth/[token].vue")
  },
  {
    name: "auth-token___fr",
    path: "/fr/auth/:token()",
    meta: _91token_932aJXYtgzXdHz26x9yfVBYasFHuJgF1oiMffT94yx65AMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/auth/[token].vue")
  },
  {
    name: "access-denied___en",
    path: "/access-denied",
    meta: access_45deniedvstioEaQp1qvNGnP0Qd4UrxscHRXaokd9Q3g1YaVanIMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/access-denied.vue")
  },
  {
    name: "access-denied___pt",
    path: "/pt/access-denied",
    meta: access_45deniedvstioEaQp1qvNGnP0Qd4UrxscHRXaokd9Q3g1YaVanIMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/access-denied.vue")
  },
  {
    name: "access-denied___fr",
    path: "/fr/access-denied",
    meta: access_45deniedvstioEaQp1qvNGnP0Qd4UrxscHRXaokd9Q3g1YaVanIMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/access-denied.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    meta: privacy_45policyhwxa6o2ppLyxbh_rIhe8pg4VoBLChwA7SbygHGpbVwIMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___pt",
    path: "/pt/privacy-policy",
    meta: privacy_45policyhwxa6o2ppLyxbh_rIhe8pg4VoBLChwA7SbygHGpbVwIMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___fr",
    path: "/fr/privacy-policy",
    meta: privacy_45policyhwxa6o2ppLyxbh_rIhe8pg4VoBLChwA7SbygHGpbVwIMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/privacy-policy.vue")
  },
  {
    name: "terms-of-service___en",
    path: "/terms-of-service",
    meta: terms_45of_45servicec7UvTpXF47aJhtjc37j0sct6y0T1MjQDiZ6MCKwwsngMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/terms-of-service.vue")
  },
  {
    name: "terms-of-service___pt",
    path: "/pt/terms-of-service",
    meta: terms_45of_45servicec7UvTpXF47aJhtjc37j0sct6y0T1MjQDiZ6MCKwwsngMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/terms-of-service.vue")
  },
  {
    name: "terms-of-service___fr",
    path: "/fr/terms-of-service",
    meta: terms_45of_45servicec7UvTpXF47aJhtjc37j0sct6y0T1MjQDiZ6MCKwwsngMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/terms-of-service.vue")
  },
  {
    name: "responsible-gaming___en",
    path: "/responsible-gaming",
    meta: responsible_45gamingmmDR5yE4uPsQDh8a9_frlN4fSo1dGG1jilb1GK6Z8zAMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/responsible-gaming.vue")
  },
  {
    name: "responsible-gaming___pt",
    path: "/pt/responsible-gaming",
    meta: responsible_45gamingmmDR5yE4uPsQDh8a9_frlN4fSo1dGG1jilb1GK6Z8zAMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/responsible-gaming.vue")
  },
  {
    name: "responsible-gaming___fr",
    path: "/fr/responsible-gaming",
    meta: responsible_45gamingmmDR5yE4uPsQDh8a9_frlN4fSo1dGG1jilb1GK6Z8zAMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/responsible-gaming.vue")
  },
  {
    name: "activate-account-token___en",
    path: "/activate-account/:token()",
    meta: _91token_93iB2LiP9GNm_45WgbGzo9m6RrXjk_45bAiJWxVIbXV5pQq4gMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/activate-account/[token].vue")
  },
  {
    name: "activate-account-token___pt",
    path: "/pt/activate-account/:token()",
    meta: _91token_93iB2LiP9GNm_45WgbGzo9m6RrXjk_45bAiJWxVIbXV5pQq4gMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/activate-account/[token].vue")
  },
  {
    name: "activate-account-token___fr",
    path: "/fr/activate-account/:token()",
    meta: _91token_93iB2LiP9GNm_45WgbGzo9m6RrXjk_45bAiJWxVIbXV5pQq4gMeta || {},
    component: () => import("/codebuild/output/src3507326296/src/luckywise/pages/activate-account/[token].vue")
  }
]